"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expansion = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const UpChevronIcon_1 = require("../../icons/UpChevronIcon");
const DownChevronIcon_1 = require("../../icons/DownChevronIcon");
const Expansion_module_css_1 = __importDefault(require("./Expansion.module.css"));
function ChevronIcon({ initExpanded, iconProps, }) {
    return initExpanded ? ((0, jsx_runtime_1.jsx)(UpChevronIcon_1.UpChevronIcon, { size: iconProps.size, className: iconProps.className, fill: iconProps.fill, "data-testid": "up_chevron_icon" })) : ((0, jsx_runtime_1.jsx)(DownChevronIcon_1.DownChevronIcon, { size: iconProps.size, className: iconProps.className, fill: iconProps.fill, "data-testid": "down_chevron_icon" }));
}
/**
 * Used for Expanding the child component
 */
function Expansion({ title, children, iconProps, onButtonClick, initExpanded = false, }) {
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(initExpanded);
    const onClickHandler = (0, react_1.useCallback)(() => {
        setIsExpanded((prev) => !prev);
        onButtonClick?.();
    }, [onButtonClick]);
    return ((0, jsx_runtime_1.jsxs)("div", { "data-testid": "expandible_container", children: [(0, jsx_runtime_1.jsxs)("div", { className: Expansion_module_css_1.default.expandibleContainer, children: [(0, jsx_runtime_1.jsx)("div", { className: Expansion_module_css_1.default.expansionTitle, "data-testid": "expansion_title", onClick: onClickHandler, children: title }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: Expansion_module_css_1.default.button, "aria-label": "Expansion Button", onClick: onClickHandler, "data-testid": "expansion_button", children: (0, jsx_runtime_1.jsx)(ChevronIcon, { initExpanded: isExpanded, iconProps: iconProps }) })] }), isExpanded && (0, jsx_runtime_1.jsx)("div", { "data-testid": "expandible_content", children: children })] }));
}
exports.Expansion = Expansion;
//# sourceMappingURL=index.js.map